import {Card, CardContent, Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {FORECAST_ORDER_COLUMN} from "../../columns/columns";
import CounterCard from "../../components/CounterCard";
import {getPendingSalesOrderDetails} from "../../services/dataService";
import ForecastOrderTable from "../../components/table/ForecastOrderTable";
import {dateBeforeMonths, today} from "../../manager/dateManager";
import {createForecastCard} from "../../manager/cardManager";
import {dispatcher, requestForecastFromStore} from "../../store/helper";
import {FORECAST_ORDER_LOADED} from "../../store/ActionType";
import store from "../../store/Store";
import {SUPPLIER_FORECAST_ORDER_COLUMN} from "../../columns/supplier-columns";
import {getUser} from "../../services/authService";

function ForecastOrders() {
  const user = getUser();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(dateBeforeMonths(4));
  const [toDate, setToDate] = useState(today());
  const [overviewItems, setOverviewItems] = useState(
    createForecastCard("loading")
  );

  const getForecastDetails = async () => {
    try {
      setLoading(true);
      const response = await getPendingSalesOrderDetails({
        FromDate: fromDate,
        ToDate: toDate,
      });
      setOverviewItems(createForecastCard([response?.data?.length]));
      dispatcher(FORECAST_ORDER_LOADED, response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setTableData([]);
      if (error.response && error.response.status === 404) {
        setOverviewItems(createForecastCard(404));
      } else {
        setOverviewItems(createForecastCard("error"));
      }
    }
  };

  useEffect(() => {
    const forecastStore = requestForecastFromStore()
    if (forecastStore.length === 0) {
      getForecastDetails();
    } else {
      setTableData(forecastStore)
      setOverviewItems(createForecastCard([forecastStore.length]))
    }
    const unsubscribe = store.subscribe(() => {
      setTableData(requestForecastFromStore())
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumns = () => {
    if (user?.globalID && (user?.isSupplierFinance || user?.isSupplierOperation))
      return SUPPLIER_FORECAST_ORDER_COLUMN;
    else if (!user?.globalID && (user?.isImpexOperation || user?.isImpexFinance)) {
      return FORECAST_ORDER_COLUMN;
    } else return FORECAST_ORDER_COLUMN;
  };

  return (
    <>
      <Grid container spacing={2} marginTop={0}>
        <Grid container spacing={2}>
          {overviewItems.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={6} lg={3}>
              <CounterCard
                description={item.name}
                title={item.value}
                icon={item.icon}
                color={item.dark}
                bgColor={item.light}
              />
            </Grid>
          ))}
          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <ForecastOrderTable
                  data={tableData}
                  columns={getColumns()}
                  fromDate={fromDate}
                  toDate={toDate}
                  handleFromDate={(e) => setFromDate(e.target.value)}
                  handleToDate={(e) => setToDate(e.target.value)}
                  callAPI={getForecastDetails}
                  loading={loading}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ForecastOrders;
